import React, {useEffect, useState} from 'react'
import AuditLogsTable from './audit-logs-table/AuditLogsTable'

const AuditLogsSettings = (props) => {
    return (
        <>
            <div title='Audit Logs'>
                <AuditLogsTable {...props} />
            </div>
        </>
    )
}

export default AuditLogsSettings
